module.exports = __webpack_public_path__ + "img/logo-small.7b4682aa.svg";